import { render, staticRenderFns } from "./GlobalSearchSingleOfferResult.vue?vue&type=template&id=5972af60"
import script from "./GlobalSearchSingleOfferResult.vue?vue&type=script&lang=js"
export * from "./GlobalSearchSingleOfferResult.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports